import api from '../lib/api';
import type { AssistantCron, AssistantCronFilters, AssistantCronResponse } from '../types/assistantCron';

class AssistantCronService {
  async list(filters?: AssistantCronFilters, page: number = 1): Promise<AssistantCronResponse> {
    const response = await api.get('/assistants/crons', {
      params: {
        ...filters,
        page,
        limit: 20,
      },
    });
    return response.data;
  }

  async get(id: number): Promise<AssistantCron> {
    const response = await api.get(`/assistants/crons/${id}`);
    return response.data;
  }

  async create(data: Partial<AssistantCron>): Promise<AssistantCron> {
    const response = await api.post('/assistants/crons', data);
    return response.data;
  }

  async update(id: number, data: Partial<AssistantCron>): Promise<AssistantCron> {
    const response = await api.put(`/assistants/crons/${id}`, data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/assistants/crons/${id}`);
  }
}

export default new AssistantCronService();
